// i18n area 'hci' — locale sr-Latn-RS (task #171, onda 4): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Script LATINO (srpska latinica, da ratificare).
// Sidecar anti-stantie: ../meta/hci.sr-Latn-RS.meta.json.
import type { enUS } from './hci'

export const srLatnRS: typeof enUS = {
  hci: {
    ceph: {
      title: 'Ceph klasteri',
      createButton: 'Kreiraj Ceph klaster',
      emptyTitle: 'Još nijedan upravljani Ceph klaster',
      emptyBody: 'TVirt deployuje i poseduje Ceph na članskim čvorovima, hiperkonvergentno sa VM opterećenjem. Kreirajte klaster: prvi monitor i njegov manager rađaju se automatski na izabranom kontrolnom čvoru — zatim ga proširite dodatnim monitorima i OSD uređajima.',
      pageTitle: 'Ceph klasteri',
      colState: 'Stanje',
      colMembers: 'Članovi',
      colSize: 'Veličina',
      colVersion: 'Ceph verzija',
      sizeCell: 'iskorišćeno {used} GiB od ukupno {total} GiB',
      phase: {
        'not-deployed': 'Nije deployovan',
        deploying: 'Deploy u toku',
        healthy: 'Zdrav',
        degraded: 'Degradiran',
        error: 'Greška',
        destroying: 'Uništavanje u toku',
        destroyed: 'Uništen'
      },
      health: {
        HEALTH_OK: 'Zdrav (HEALTH_OK)',
        HEALTH_WARN: 'Sa upozorenjima (HEALTH_WARN)',
        HEALTH_ERR: 'Sa greškom (HEALTH_ERR)',
        unknown: 'Još nije posmatrano',
        observedAt: 'posmatrano {time}'
      },
      create: {
        title: 'Kreirajte Ceph klaster',
        info: 'Kada se kreira novi Ceph klaster, bira se prvi čvor na koji će biti instalirane uloge MON i MGR. Takođe treba navesti koju podmrežu koristiti za Ceph saobraćaj: public podmreža se koristi za opšti mrežni saobraćaj, dok se klaster podmreža koristi za interne replike između OSD-ova; različite podmreže nisu strogo neophodne.',
        controlNode: 'Kontrolni čvor',
        controlNodeHint: 'Članski čvor na kom se rađaju prvi MON + MGR.',
        publicSubnet: 'Public podmreža',
        publicSubnetHint: 'Subnet registrovana u IPAM-u — Cephova public_network. Nepromenljiva posle kreiranja.',
        clusterSubnet: 'Klaster podmreža',
        clusterSubnetHint: 'Subnet registrovana u IPAM-u — Cephova cluster_network (replikacija/backfill).',
        noSubnets: 'Nijedna Subnet nije registrovana — prvo ih kreirajte u IPAM-u',
        sameSubnet: 'Ista podmreža za public i klaster saobraćaj',
        sameSubnetHint: 'Označeno = klaster mreža (replikacija/backfill) poklapa se sa public mrežom. Neoznačeno = izaberite za nju sopstvenu podmrežu I adresu kontrolnog čvora unutar nje.',
        controlAddress: 'Adresa kontrolnog čvora',
        controlAddressHint: 'Adresa koju IPAM poznaje za čvor unutar public podmreže.',
        controlClusterAddress: 'Klaster adresa kontrolnog čvora',
        controlClusterAddressHint: 'Adresa koju IPAM poznaje za čvor unutar klaster podmreže.',
        noAddresses: 'IPAM ne poznaje nijednu adresu ovog čvora unutar izabrane podmreže',
        started: 'Klaster kreiran — bootstrap se nastavlja kao makrozadatak; faza se sama ažurira',
        error: 'Klaster je odbijen'
      },
      detail: {
        actions: 'Dostupne akcije',
        tabOverview: 'Pregled',
        tabManagementNodes: 'MON & MGR',
        tabDisks: 'OSD',
        tabPools: 'Poolovi',
        tabObjects: 'Objekti',
        tabCrush: 'CRUSH Map',
        tabCephfs: 'CephFS',
        tabAdvanced: 'Napredno',
        phase: 'Faza',
        checksTitle: 'Aktivne provere zdravlja',
        noChecks: 'Nijedna aktivna provera zdravlja',
        checkMuted: 'utišan',
        summaryPools: 'Poolovi',
        summaryFilesystems: 'Filesystemi',
        nodesCard: 'Čvorovi',
        monHint: 'MGR radi kolociran uz svaki MON. Tri MON-a su preporučeni kvorum; laboratorijski klaster kreće sa jednim. OSD-ovi i MDS-ovi žive u svojim tabovima.',
        monHintSplit: 'MON i MGR su razdvojeni na ovom klasteru (Napredno): svaka uloga je sopstveno članstvo po čvoru. Tri MON-a su preporučeni kvorum; bar jedan MGR mora postojati.',
        noMons: 'Nijedan monitor nije deklarisan',
        addNode: 'Dodaj čvor',
        removeNode: 'Ukloni čvor',
        removeNodeFrom: 'Ukloni čvor {node} (njegov MON i kolocirani MGR)',
        roleMon: 'Uloga MON',
        roleMgr: 'Uloga MGR',
        roleNa: 'N/A',
        roleNotObserved: 'još nije posmatrana',
        monInQuorum: 'u kvorumu',
        monOutQuorum: 'van kvoruma',
        mgrActive: 'aktivan',
        mgrStandby: 'standby',
        addRoleMon: 'Dodaj ulogu MON',
        removeRoleMon: 'Ukloni ulogu MON',
        addRoleMgr: 'Dodaj ulogu MGR',
        removeRoleMgr: 'Ukloni ulogu MGR',
        restartMon: 'Restartuj MON servis',
        restartMgr: 'Restartuj MGR servis',
        addMon: 'Dodaj MON',
        removeMon: 'Ukloni MON',
        removeMonFrom: 'Ukloni ulogu MON sa čvora {node}',
        addMgr: 'Dodaj MGR',
        removeMgr: 'Ukloni MGR',
        removeMgrFrom: 'Ukloni ulogu MGR sa čvora {node}',
        addMds: 'Dodaj MDS',
        removeMds: 'Ukloni MDS',
        removeMdsFrom: 'Ukloni ulogu MDS sa čvora {node}',
        mdsSection: 'Metadata serveri (MDS)',
        noMds: 'Nijedan MDS nije deklarisan — filesystemu je prvo potreban jedan',
        mdsHint: 'Članstvo MDS-ova je sopstveno od prvog dana: klaster bez CephFS-a ne deklariše nijedan, jedan aktivan plus jedan standby dobro služe filesystem. Ceph bira aktivne i standby među deklarisanim demonima.',
        mdsActiveFor: 'aktivan — {fs}',
        mdsNotObserved: 'još nije posmatran',
        lastMdsGuard: 'Poslednji MDS se ne može ukloniti dok postoji filesystem — prvo uklonite filesysteme',
        lastMonGuard: 'Poslednji MON se ne može ukloniti — uništavanje klastera je jedini izlaz',
        lastMgrGuard: 'Poslednji MGR se ne može ukloniti — upravljani klaster nikada ne radi bez managera',
        registerDevice: 'Dodaj OSD',
        unregisterDevice: 'Deregistruj',
        activeDeviceGuard: 'Aktivan OSD — izlazi kroz životni ciklus OSD-a, ne kroz registar',
        colNode: 'Čvor',
        devicePhase: { registered: 'Registrovan', active: 'Aktivan' },
        health: 'Zdravlje',
        state: 'Stanje',
        fsid: 'fsid',
        fsidPending: 'odsutan — ponovite bootstrap',
        version: 'Ceph verzija',
        publicNetwork: 'Public mreža',
        clusterNetwork: 'Klaster mreža',
        clusterNetworkCollapsed: '= public',
        noActions: 'Nijedna akcija nije dostupna u ovoj fazi',
        destroyedNote: 'Klaster uništen — red se ubrzo automatski uklanja'
      },
      overview: {
        services: 'Servisi',
        ok: 'zdravo',
        warning: 'warning',
        down: 'down',
        pgTitle: 'Stanja PG-ova',
        pgTotal: 'ukupno PG-ova: {n}',
        capacityTitle: 'Prostor',
        ioTitle: 'Trenutni I/O',
        ioReadBw: 'Protok pri čitanju',
        ioWriteBw: 'Protok pri pisanju',
        ioReadIops: 'IOPS pri čitanju',
        ioWriteIops: 'IOPS pri pisanju',
        notObserved: 'još nije posmatrano'
      },
      osd: {
        colId: 'ID',
        colClass: 'Device class',
        colState: 'Stanje',
        colSize: 'Veličina',
        colPgs: 'PG',
        empty: 'Još nema OSD-ova — dodajte jedan iz deklarisanog diska za podatke',
        markIn: 'Označi IN',
        markOut: 'Označi OUT',
        scrub: 'Pokreni scrub',
        deepScrub: 'Pokreni duboki scrub',
        restart: 'Restartuj servis',
        details: 'Detalji',
        actionGuard: 'Samo na aktivnom OSD-u deployovanog klastera',
        inTitle: 'Označite OSD IN',
        inBody: 'osd.{id} se vraća u raspodelu podataka (ceph osd in): Ceph rebalansira podatke nazad na njega.',
        outTitle: 'Označite OSD OUT',
        outBody: 'osd.{id} napušta raspodelu podataka (ceph osd out): njegovi podaci se rebalansiraju drugde i redundansa je SMANJENA dok backfill traje. Reverzibilno u svakom trenutku pomoću Označi IN.',
        scrubTitle: 'Zakažite scrub',
        scrubBody: 'Zakazuje se scrub za osd.{id}: mon ga stavlja u red čekanja, a stanja PG-ova u narednim sweepovima pokazuju ishod.',
        deepScrubTitle: 'Zakažite duboki scrub',
        deepScrubBody: 'Zakazuje se duboki scrub za osd.{id}: varijanta koja verifikuje bajtove — teža za I/O, ista mehanika.',
        restartTitle: 'Restartujte OSD servis',
        restartBody: 'osd.{id} se zaustavlja i ponovo pokreće kroz nadzor workera na njegovom čvoru.',
        started: 'Akcija pokrenuta — osmatranje se samo ažurira',
        error: 'OSD akcija je odbijena'
      },
      osdDetail: {
        title: 'Detalji OSD-a',
        tabGeneral: 'Opšte',
        tabNetwork: 'Mreža',
        tabDevices: 'Uređaji',
        version: 'Verzija',
        hostname: 'Hostname',
        dataPath: 'Putanja OSD podataka',
        objectStore: 'OSD object store',
        encrypted: 'Šifrovan',
        yes: 'Da',
        no: 'Ne',
        memory: 'Upotreba memorije (PSS)',
        pid: 'Process ID (PID)',
        front: 'Front adresa (klijent & monitor)',
        hbFront: 'Heartbeat front adresa',
        back: 'Back adresa (OSD)',
        hbBack: 'Heartbeat back adresa',
        colDevice: 'Device',
        colType: 'Tip',
        colPhysical: 'Fizički device',
        colSize: 'Veličina',
        volumeTitle: 'Detalji volumena',
        creationTime: 'Datum kreiranja',
        lvName: 'LV Name',
        lvPath: 'LV Path',
        lvUuid: 'LV UUID',
        vgName: 'VG Name',
        noDevices: 'Nijedan device nije posmatran za ovaj OSD'
      },
      restart: {
        title: 'Restartujte servis',
        monBody: 'Demon MON na čvoru {node} se zaustavlja i ponovo pokreće kroz nadzor workera.',
        mgrBody: 'Demon MGR na čvoru {node} se zaustavlja i ponovo pokreće kroz nadzor workera.',
        started: 'Restart pokrenut — osmatranje se samo ažurira',
        error: 'Restart je odbijen'
      },
      encryptionMode: {
        alwaysOn: 'Uvek omogućeno (dmcrypt)',
        alwaysOff: 'Uvek onemogućeno',
        perOsd: 'Izbor po svakom OSD-u',
        section: 'Šifrovanje OSD-a at rest',
        title: 'Promenite režim šifrovanja OSD-a',
        hint: 'Kako se pripremaju NOVI OSD-ovi. Postojeći OSD-ovi zadržavaju svoje stanje po disku: da biste ga promenili, uklonite OSD i ponovo ga kreirajte.',
        body: 'Režim postaje „{mode}“ i važi SAMO za NOVE OSD-ove: svaki postojeći OSD zadržava svoje trenutno stanje šifrovanja.',
        apply: 'Promeni režim',
        error: 'Promena režima je odbijena'
      },
      pin: {
        address: 'Public adresa (opcioni pin)',
        clusterAddress: 'Klaster adresa (opcioni pin)',
        autoPlaceholder: 'automatski unutar podmreže {cidr}',
        hint: 'Adresiranje po demonu: prazno = Ceph se sam vezuje unutar deklarisane mreže; postavljeno = ova instanca demona je pinovana na adresu u svojoj conf sekciji.'
      },
      addMon: {
        title: 'Dodajte čvor',
        node: 'Čvor',
        address: 'Public adresa',
        addressHint: 'Adrese čvora koje IPAM poznaje unutar public podmreže — automatski kada postojeća deklaracija pokriva čvor.',
        clusterAddress: 'Klaster adresa',
        clusterAddressHint: 'Obavezno: klaster podmreža je odvojena i čvor na njoj još nije deklarisan.',
        noAddresses: 'IPAM ne poznaje nijednu adresu ovog čvora unutar podmreže',
        error: 'Dodavanje mona je odbijeno'
      },
      removeMon: {
        title: 'Uklonite MON',
        body: 'MON i njegov kolocirani MGR napuštaju čvor {node}. Na deployovanom klasteru demoni se zaustavljaju i uklanjaju iz kvoruma.',
        error: 'Uklanjanje MON-a je odbijeno'
      },
      addMgr: {
        title: 'Dodajte MGR',
        node: 'Čvor',
        hint: 'Napredno (razdvojeni MON/MGR): standalone manager rađa se na izabranom članskom čvoru zadatkom vezanim za čvor. Cephov sopstveni active/standby izbor sam bira aktivni MGR.',
        error: 'Dodavanje MGR-a je odbijeno'
      },
      removeMgr: {
        title: 'Uklonite MGR',
        body: 'Standalone MGR napušta čvor {node}. Na deployovanom klasteru demon se zaustavlja i njegovo stanje uklanja; MON tog čvora (ako postoji) ostaje netaknut.',
        error: 'Uklanjanje MGR-a je odbijeno'
      },
      addMds: {
        title: 'Dodajte MDS',
        node: 'Čvor',
        hint: 'Metadata server CephFS-a: rađa se na izabranom članskom čvoru zadatkom vezanim za čvor, pod nadzorom workera kao MON i MGR. Ceph sam bira aktivne i standby — jedan aktivan plus jedan standby dobro služe filesystem.',
        error: 'Dodavanje MDS-a je odbijeno'
      },
      removeMds: {
        title: 'Uklonite MDS',
        body: 'MDS napušta čvor {node}. Na deployovanom klasteru demon se zaustavlja i njegovo stanje uklanja; API odbija poslednji MDS dok ga neki filesystem još treba.',
        error: 'Uklanjanje MDS-a je odbijeno'
      },
      split: {
        title: 'Razdvojeni MON/MGR',
        label: 'Dozvoli MON i MGR na razdvojenim čvorovima',
        hint: 'Isključeno (podrazumevano) = ratifikovani standard: MGR radi kolociran uz svaki MON, jedno jedino članstvo. Uključeno = članstvo MGR-ova postaje sopstveno, upravljano akcijama Dodaj/Ukloni MGR u tabu Upravljački čvorovi.',
        enable: 'Uključi',
        disable: 'Isključi',
        enableBody: 'Članstvo MGR-ova postaje nezavisno od MON-ova, inicijalizovano iz trenutne kolokacije. Akcije Dodaj/Ukloni MGR aktiviraju se u tabu Upravljački čvorovi. Ovo opušta podrazumevano ponašanje platforme — zadržite ga samo ako znate zašto vam treba.',
        disableBody: 'Povratak na standardnu kolokaciju: MGR uz svaki MON, jedno jedino članstvo. Legalno samo dok se članstvo MGR-ova već poklapa sa MON-ovima — prvo ga poravnajte akcijama Dodaj/Ukloni MGR, ili će API odbiti.',
        error: 'Izmena je odbijena'
      },
      rawEditor: {
        title: 'Sirovi CRUSH editor',
        label: 'Prikaži sirovi crushmap editor u tabu CRUSH',
        hint: 'Isključeno (podrazumevano) = vođena površina pravila je standardni alat. Uključeno = tab CRUSH prikazuje i dekompajlirani crushmap kao tekst koji se može uređivati. Čuvanje uvek zahteva sudo, ime klastera kao potvrdu, i prolazi kroz crushtool compile + test PRE nego što stigne do klastera.'
      },
      osdFlags: {
        section: 'Globalni OSD flagovi',
        title: 'Override OSD flagova',
        notObserved: 'još nisu posmatrani',
        standardFlowsHint: 'Standardni tokovi platforme sami upravljaju ovim flagovima u normalnim slučajevima (održavanje čvora postavlja ciljani noout, zamena diska ide kroz životni ciklus OSD-a). Ova sekcija je ručni override za operatera koji zna šta radi.',
        notDeployedGuard: 'OSD flagovi postoje samo na deployovanom klasteru',
        set: 'Postavi flag',
        unset: 'Ukloni flag',
        setBody: 'Globalni flag {flag} biće POSTAVLJEN na osdmapu. Ostaje dok se eksplicitno ne ukloni — zaboravljen flag degradira samooporavak klastera.',
        unsetBody: 'Globalni flag {flag} biće UKLONJEN sa osdmapa.',
        error: 'Promena flaga je odbijena',
        flag: {
          noout: 'Nijedan OSD se ne označava out iz raspodele podataka — nema rebalansa pri gubitku demona',
          norebalance: 'Rebalans podataka je suspendovan',
          nobackfill: 'Backfill je suspendovan',
          norecover: 'Recovery je suspendovan',
          pause: 'SAV klijentski I/O je pauziran (čitanja i pisanja)',
          noin: 'OSD-ovi koji se podižu ne označavaju se in automatski',
          nodown: 'Nedostupni OSD-ovi se ne označavaju down — maskira stvarne otkaze'
        }
      },
      pools: {
        section: 'Poolovi',
        create: 'Kreiraj pool',
        createGuard: 'Poolovi postoje samo na deployovanom klasteru',
        notObserved: 'Još nema osmatranja poolova — mon sweep izveštava ovde',
        empty: 'Nijedan pool na klasteru',
        colName: 'Ime',
        colReplication: 'Size / min size',
        colPgNum: 'PG',
        colApplication: 'Aplikacija',
        colRule: 'CRUSH pravilo',
        colUsage: 'Iskorišćenost',
        observedAtLabel: 'Posmatrano',
        objects: 'objekata: {n}',
        inUseBy: 'koristi ga {name}',
        internalGuard: 'Interni Cephov pool — platforma ga nikada ne briše',
        delete: 'Obriši pool',
        deleteGuard: 'Konzumira ga storage {name} — prvo obrišite storage',
        hint: 'Samo replikovani poolovi (erasure coding je van scopea v1). Replikacija živi u Cephu: ova tabela je posmatrana istina iz mon sweepa.',
        createTitle: 'Kreirajte pool',
        createHint: 'Pool se rađa na klasteru sa traženom replikacijom i uključenom rbd aplikacijom — posao obavlja zadatak na MON čvoru. Uključite „Predloži kao storage“ da ga odmah konzumirate istim gestom.',
        name: 'Ime poola',
        nameHint: 'DNS-safe (mala slova, cifre, crtice).',
        size: 'Replike (size)',
        sizeHint: 'Kopije svakog objekta. Podrazumevano 3.',
        minSize: 'Minimalne replike (min_size)',
        minSizeHint: 'Minimalne kopije za posluživanje I/O — prati size − 1 dok ga ne izmenite.',
        createError: 'Kreiranje poola je odbijeno',
        deleteTitle: 'Obrišite pool',
        deleteBody: 'Pool {pool} i SVAKI objekat u njemu uništavaju se nepovratno. Unesite ime poola za potvrdu.',
        confirmLabel: 'Ime poola',
        confirmHint: 'Unesite ime poola za potvrdu',
        deleteError: 'Brisanje poola je odbijeno',
        detailTitle: 'Detalji poola',
        autoscaler: 'PG Autoscaler',
        autoscalerOn: 'Uključen',
        autoscalerOff: 'Isključen',
        autoscalerWarn: 'Obavesti',
        pgNumLabel: 'Broj PG-ova',
        pgNumCaption: 'Posmatrano: autoscaler ga može promeniti sam od sebe — ovo polje upisuje želju.',
        storage: 'Pridruženi TVirt storage',
        addAsStorage: 'Dodaj kao TVirt storage',
        ruleSudoHint: 'Promena CRUSH pravila zahteva lozinku operatera.',
        updateError: 'Izmena poola je odbijena',
        updated: 'Izmena poola pokrenuta — osmatranje se samo ažurira'
      },
      crush: {
        section: 'CRUSH pravila',
        notObserved: 'Još nema CRUSH osmatranja — mon sweep izveštava ovde',
        empty: 'Nijedno pravilo nije posmatrano na klasteru',
        hint: 'Pravilo odlučuje GDE završavaju kopije svakog objekta — njegov domen otkaza je jedinica koja može da otkaže bez gubitka podataka. Poolovi pokazuju na pravilo; builtin replicated_rule (jedna replika po serveru) je podrazumevano pravilo od rođenja.',
        create: 'Kreiraj pravilo',
        createGuard: 'CRUSH pravila postoje samo na deployovanom klasteru',
        createTitle: 'Kreirajte CRUSH pravilo',
        createHint: 'Jedno pravilo = jedan izbor domena otkaza. Pravilo se rađa replikovano na podrazumevanom rootu — posao obavlja zadatak na MON čvoru; poolove pridružite naknadno iz taba Poolovi.',
        createError: 'Kreiranje pravila je odbijeno',
        name: 'Ime pravila',
        nameHint: 'DNS-safe (mala slova, cifre, crtice).',
        domain: 'Domen otkaza',
        domainChoice: {
          osd: 'Svaka replika na različitom OSD-u',
          host: 'Svaka replika na različitom serveru',
          rack: 'Svaka replika u različitom racku'
        },
        domainCustom: 'Prilagođeno (ručno napisani stepovi)',
        domainOther: 'Svaka replika u različitom bucketu tipa {type}',
        rackGuardHint: 'Nijedan rack bucket ne postoji u posmatranoj hijerarhiji: pravilo se svakako može kreirati, ali nijedan pool ne može da pokaže na njega dok rack ne bude deklarisan u razmeštaju članskih servera (podešavanja čvora) — zadatak poravnanja gradi bucket i pridruživanje se otvara samo od sebe.',
        treeTitle: 'Posmatrana hijerarhija',
        treeNotObserved: 'Još nema osmatranja hijerarhije — mon sweep izveštava ovde',
        treeOsds: 'OSD-ova: {n}',
        treeHint: 'CRUSH mapa onako kako je klaster vidi: root → deklarisani nivoi → serveri (hostovi) → OSD-ovi. Topologija prati deklarisani razmeštaj svakog servera (podešavanja čvora) — promena razmeštaja je ponovo poravnava kroz zadatak.',
        unplacedWarning: 'Članovi bez deklarisanog razmeštaja: {nodes} — njihovi hostovi ostaju direktno ispod roota, izvan deklarisane topologije. Deklarišite poziciju u podešavanjima čvora (upozorenje, nikada blokada).',
        colName: 'Ime',
        colDomain: 'Domen otkaza',
        colPools: 'Poolovi',
        builtinChip: 'builtin',
        builtinGuard: 'Podrazumevano pravilo klastera — platforma ga nikada ne briše',
        detailAction: 'Detalj pravila',
        detailType: 'Tip',
        backToRules: 'Pravila',
        ruleNotObserved: 'Posmatrana lista pravila ne imenuje ovo pravilo',
        noPools: 'Nijedan pool ne koristi ovo pravilo',
        delete: 'Obriši pravilo',
        deleteTitle: 'Obrišite CRUSH pravilo',
        deleteBody: 'Pravilo {rule} uklanja se iz crushmapa klastera. Nijedan pool ne sme da ga koristi. Unesite ime pravila za potvrdu.',
        deleteGuard: 'Koristi ga pool {name} — prvo preusmerite pool',
        confirmLabel: 'Ime pravila',
        confirmHint: 'Unesite ime pravila za potvrdu',
        deleteError: 'Brisanje pravila je odbijeno',
        changeRule: 'Promeni CRUSH pravilo',
        changeRuleTitle: 'Promenite CRUSH pravilo',
        changeRuleHint: 'Pool počinje da raspoređuje svoje objekte po izabranom pravilu — Ceph premešta postojeće podatke radi usklađivanja (na punom poolu sledi rebalans).',
        changeRuleError: 'Promena pravila je odbijena',
        rule: 'CRUSH pravilo',
        rawTitle: 'Sirovi crushmap (dekompajliran)',
        rawWarning: 'OPASNOST: ovaj tekst je CELOKUPNA politika razmeštaja klastera. Pogrešna mapa može odjednom da slomi placement svih poolova. Čuvanje kompajlira i testira mapu crushtoolom PRE ubacivanja — ali i validna mapa svejedno može biti loša ideja.',
        rawReload: 'Ponovo učitaj',
        rawLoading: 'Query u toku — read-only zadatak dekompajlira crushmap…',
        rawSave: 'Sačuvaj crushmap',
        rawSaveTitle: 'Ubacite crushmap',
        rawSaveBody: 'Izmenjeni tekst zamenjuje crushmap CELOG klastera posle crushtool compile + test. Unesite ime klastera za potvrdu.',
        rawConfirmLabel: 'Ime klastera',
        rawConfirmHint: 'Unesite {name} za potvrdu',
        rawError: 'Operacija nad crushmapom nije uspela',
        rawHint: 'Tekst je u crushtool -d obliku. Greške kompajliranja i padovi testa vraćaju se doslovno iz crushtoola — mapa nikada ne stiže do klastera ako bilo koja od dve kapije padne.'
      },
      objects: {
        poolsSection: 'Istraživač objekata',
        poolsHint: 'Izaberite pool da izlistate njegove RBD slike. Svako duboko čitanje radi kao read-only zadatak na MON čvoru — nikada ne blokira stvarne operacije (niti ga one blokiraju).',
        deployedGuard: 'Query nad objektima odgovaraju samo na deployovanom klasteru',
        browse: 'Pregledaj objekte',
        detailAction: 'Detalj slike',
        backToPools: 'Poolovi',
        backToImages: 'Slike',
        refresh: 'Osveži',
        loading: 'Query u toku — read-only zadatak ispituje klaster…',
        error: 'Query nije uspeo',
        retry: 'Pokušaj ponovo',
        notRbd: 'Pool sa application „{app}“ — ne sadrži RBD slike, ovde nema šta da se istražuje',
        noImages: 'Nijedna RBD slika u ovom poolu',
        colImage: 'Slika',
        colSize: 'Veličina',
        colObjects: 'Objekti',
        colSnapshots: 'Snimci',
        imagesHint: 'Diskovi na konzumirajućem rbd storageu su slike nazvane po id-u svog diska. Broj objekata je provisioned (veličina / veličina objekta) — stvarna upotreba živi u detalju slike.',
        infoTitle: 'Slika',
        infoSize: 'Virtuelna veličina',
        infoObjects: 'Objekti (provisioned)',
        infoObjectSize: 'Veličina objekta',
        infoPrefix: 'Prefiks objekata',
        infoFormat: 'Format',
        infoFeatures: 'Feature',
        usageTitle: 'Stvarna upotreba (rbd du)',
        usageOf: 'od {provisioned} GiB provisioned',
        usageHint: 'Thin po prirodi: samo upisani objekti zauzimaju bajtove.',
        watchersTitle: 'Watcheri',
        noWatchers: 'Nijedan watcher — niko trenutno nema ovu sliku otvorenu',
        snapshotsTitle: 'RBD snimci',
        noSnapshots: 'Nijedan RBD snimak na ovoj slici',
        colSnapshot: 'Snimak',
        colProtected: 'Zaštićen',
        colTimestamp: 'Kreiran',
        protected: 'zaštićen',
        mappingTitle: 'Fizički razmeštaj (OSD skup)',
        mappingSampled: 'Uzorkovani objekti: {sampled} od {total} — pošten rezime: za velike slike skup konvergira ka SVIM OSD-ovima poola (CRUSH raspoređuje objekte po celom poolu).',
        mappingComplete: 'Svi objekti mapirani ({total} od {total}).',
        objectQueryTitle: 'Mapirajte pojedinačni objekat',
        objectName: 'Ime objekta',
        objectHint: 'Imena RADOS objekata su <prefiks>.<16-hex indeks> — ceph osd map odgovara PG-om i OSD skupovima.',
        mapObject: 'Mapiraj',
        primary: 'primarni: osd.{osd}'
      },
      registerDevice: {
        title: 'Registrujte OSD uređaj',
        hint: 'Na živom klasteru registracija i PRIPREMA uređaj: postaje BlueStore OSD kroz automatski zadatak vezan za čvor (nikada prazan, ratifikovano 2026-07-24). Uređaj pripada najviše jednom Ceph klasteru u celoj floti.',
        disk: 'Disk za podatke',
        diskHint: 'Deklarisani diskovi za podatke ovog čvora — ime i pin serijskog broja',
        noDeclared: 'Nijedan disk za podatke nije deklarisan na ovom čvoru — prvo ih označite u lokalnim podešavanjima čvora',
        serialHint: 'Serijski broj uređaja — pin identiteta',
        encrypted: 'Šifruj ovaj OSD (dmcrypt)',
        encryptedHint: 'Izbor po OSD-u (režim klastera je „izbor po svakom OSD-u“): zamrzava se na ovom disku pri registraciji — kasnija promena režima ga nikada ne prepisuje; to radi akcija reda šifruj/dešifruj.',
        error: 'Registracija je odbijena'
      },
      unregisterDevice: {
        title: 'Deregistrujte uređaj',
        body: 'Samo registar: {name} prestaje da bude OSD kandidat ovog klastera. Njegovi bajtovi se ne diraju.',
        error: 'Deregistracija je odbijena'
      },
      deploy: {
        action: 'Ponovi deploy',
        title: 'Ponovite bootstrap',
        body: 'Bootstrap rođenja kreće ponovo od trenutne konfiguracije: monovi se pokreću, svaki registrovani uređaj se priprema i aktivira kao BlueStore OSD. Operacija radi kao makrozadatak — faza se sama ažurira.',
        started: 'Bootstrap pokrenut — nastavlja kao makrozadatak; faza se sama ažurira',
        error: 'Bootstrap je odbijen'
      },
      propose: {
        action: 'Predloži kao storage',
        title: 'Predložite kao storage',
        hintPool: 'Postojeći pool {name} postaje TVirt storage: cephx identitet ograničen na pool sleće u keystore i ceph-rbd storage se rađa spreman. Predlog konzumira pool — nikada ga ne kreira.',
        hintFs: 'Postojeći filesystem {name} postaje TVirt storage: cephx identitet ograničen na filesystem sleće u keystore i cephfs storage se rađa spreman i montiran. Predlog konzumira filesystem — nikada ga ne kreira.',
        name: 'Ime storagea',
        nameHint: 'DNS-1123, jedinstveno u scopeu — cephx identitet dobija ime po njemu.',
        path: 'Putanja unutar filesystema',
        pathHint: 'Apsolutna putanja unutar filesystema koji storage montira — / ako ste u nedoumici.',
        alsoPropose: 'Predloži odmah kao storage',
        alsoProposePoolHint: 'Posle kreiranja isti gest predlaže novorođeni pool kao ceph-rbd storage — dva eksplicitna poziva, jedan dijalog.',
        alsoProposeFsHint: 'Posle kreiranja isti gest predlaže novorođeni filesystem kao cephfs storage — dva eksplicitna poziva, jedan dijalog.',
        guard: 'Predloži kao storage — samo na healthy klasteru',
        started: 'Predlog prihvaćen — storage se materijalizuje; naći ćete ga pod Storage',
        submit: 'Kreiraj storage',
        error: 'Predlog je odbijen'
      },
      fs: {
        section: 'Filesystemi',
        create: 'Kreiraj filesystem',
        createGuard: 'Filesystemi postoje samo na deployovanom klasteru',
        mdsFirstGuard: 'Prvo dodajte MDS — filesystem bez metadata servera rađa se neupotrebljiv',
        notObserved: 'Još nema osmatranja filesystema — MON sweep izveštava ovde',
        empty: 'Nijedan filesystem na klasteru',
        colName: 'Ime',
        colPools: 'Poolovi',
        colMds: 'MDS',
        noActiveMds: 'nijedan aktivan MDS',
        delete: 'Ukloni filesystem',
        deleteGuard: 'Konzumira ga storage {name} — prvo obrišite storage',
        hint: 'Filesystem poseduje svoje poolove za podatke i metapodatke (cephfs.<ime>.data / .meta): rađaju se s njim i umiru s njim — removeFs, nikada ručno brisanje poola. Ova tabela je posmatrana istina iz MON sweepa.',
        createTitle: 'Kreirajte filesystem',
        createHint: 'Filesystem se rađa na klasteru sa svoja dva poola (application cephfs) i služe ga deklarisani MDS-ovi — posao obavlja zadatak na MON čvoru. Uključite „Predloži kao storage“ da ga odmah konzumirate istim gestom.',
        name: 'Ime filesystema',
        nameHint: 'DNS-safe (mala slova, cifre, crtice).',
        sizeHint: 'Replike OBA novorođena poola. Podrazumevano 3.',
        createError: 'Kreiranje filesystema je odbijeno',
        deleteTitle: 'Uklonite filesystem',
        deleteBody: 'Filesystem {fs} i SVAKA datoteka u njemu uništavaju se nepovratno — njegovi poolovi za podatke i metapodatke umiru s njim. Unesite ime filesystema za potvrdu.',
        confirmLabel: 'Ime filesystema',
        confirmHint: 'Unesite ime filesystema za potvrdu',
        deleteError: 'Uklanjanje filesystema je odbijeno'
      },
      destroy: {
        action: 'Uništi',
        retryAction: 'Ponovi uništavanje',
        retryGuard: 'Uništavanje je u toku — ponovni pokušaj važi za neuspelo uništavanje (lease ga inače odbija)',
        title: 'Uništite klaster',
        body: 'Deployovani fabric se ruši: svaki demon ovog klastera se zaustavlja, njegovo sistemsko stanje i ključevi u keystoreu se oslobađaju. Kad uništavanje uspe, klaster se automatski uklanja.',
        confirmLabel: 'Ime klastera',
        confirmHint: 'Unesite ime klastera za potvrdu',
        wipe: 'Obriši registrovane uređaje',
        wipeHint: 'Označeno: potpisi svakog registrovanog uređaja se brišu — podaci na njima su uništeni. Neoznačeno: bajtovi ostaju netaknuti i uređaji se vraćaju u registrovane.',
        guard: 'Uništi — ništa nije deployovano',
        started: 'Uništavanje pokrenuto — nastavlja kao makrozadatak; faza se sama ažurira',
        error: 'Uništavanje je odbijeno'
      },
      delete: {
        guard: 'Obriši — samo konfiguracija koja nije deployovana (prvo uništite)',
        title: 'Obrisati {name}?',
        body: 'Konfiguracija i njen registar uređaja se uklanjaju. Legalno samo dok ništa nije deployovano.',
        error: 'Brisanje je odbijeno'
      }
    }
  }
}
